import * as React from "react";
import { Types, TooltipFormat } from "./controller-props";
import ControllerState from "./controller-state";
//import './Controller.css';

import { RangeComponent } from "@att-bit/gvp.atoms.range-component";
// import { TooltipFormat } from '../RangeComponent/RangeComponentProps';
import { Timecode } from "./timecode-controller";
import { VolumeController } from "@att-bit/gvp.atoms.volume-controller";
import { Utils } from "./utils-controller";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import {
  fullScreenExitIcon,
  fullScreenIcon,
  ccIcon,
  pauseIcon,
  playIcon,
  transcriptCollapse,
  transcriptOpen,
} from "./constants-icons";

export type ControllerProps = {
  /**
   *  Data to load Controller
   */
  data: ControllerData;
  /**
   *  Events for the Controller
   */
  events?: ControllerEvents;
  /**
   *  Additional options for Controller to enable different interfaces like Model etc.
   */
  options?: ControllerOptions;
  /**
   *  Additional id passed to Controller
   */
  testId?: string;
};

export type ControllerData = {
  caption: boolean;
  chapteredVideoData: any;
  currentTime: number;
  fullScreen: boolean;
  mute?: boolean;
  playing: boolean;
  totalTime: number;
  transcript: boolean;
  volume?: number;
  showTranscript: boolean;
  showCaption: boolean;
};

export type ControllerOptions = {
  enlarge?: boolean;
  className?: string;
  showFullScreen?: boolean;
  showCaption?: boolean;
  showTranscript?: boolean;
  containerWidth?: any;
  modal?: boolean;
};

export type ControllerEvents = {
  handlePlayPause?(playPause: boolean): void;
  captionClick?(showing: boolean): void;
  fullScreenClick?(fullScreen: boolean): void;
  transcriptClick?(showTranscript: boolean): void;
  handleMute?(mute: boolean, volumn: number): void;
  handleVolumeChange?(mute: boolean, volumn: number): void;
  handleSeekVideo?(value: number): void;
};

export class Controller extends React.Component<ControllerProps, ControllerState> {
  state: ControllerState;

  constructor(props: ControllerProps) {
    super(props);
    this.state = {
      fullScreen: false, // this.props.data && this.props.data.fullScreen,
      playing: this.props.data && this.props.data.playing,
      showCaption: false, // this.props.data && this.props.data.showCaption,
      showTranscript: false, // this.props.data && this.props.data.showTranscript,
      controllerContainerClassName: '' 
    };
    this.getPlayBtn = this.getPlayBtn.bind(this);
    this.handlePlayPause = this.handlePlayPause.bind(this);
    this.handleVideoRange = this.handleVideoRange.bind(this);
    this.hanldeCaptionbuttonClick = this.hanldeCaptionbuttonClick.bind(this);
    this.handleFullScreen = this.handleFullScreen.bind(this);
    this.handleMuteUnmute = this.handleMuteUnmute.bind(this);
    this.handleTranscriptClick = this.handleTranscriptClick.bind(this);
  }

  componentWillReceiveProps(nextProps: ControllerProps) {
    if (nextProps.data.playing !== this.state.playing
      || nextProps.data.fullScreen !== this.state.fullScreen
      || nextProps.data.caption !== this.state.showCaption) {
      this.setState({
        fullScreen: nextProps.data.fullScreen,
        playing: nextProps.data.playing,
        showCaption: nextProps.data.caption,
      });
    }
  }
 
  componentDidMount() {
    let controllerContainerClassName = '';
    if(this.props.options.containerWidth  > 400 && this.props.options.containerWidth  <= 600 ){
      controllerContainerClassName = 'Controller__controller__GT400__LT600';
    }else if(this.props.options.containerWidth  > 251 && this.props.options.containerWidth  <= 400  ){
      controllerContainerClassName = 'Controller__controller__GT250__LT400';
    }else if(this.props.options.containerWidth  <= 250 ){
      controllerContainerClassName = 'Controller__controller__LT250';
    }
    this.setState({controllerContainerClassName: controllerContainerClassName});
  }

  render() {
    const timeleft = this.props.data.totalTime - this.props.data.currentTime;
    const timeLeftStr = Timecode.secondsToTimecode(timeleft >= 0 ? timeleft : 0)!.trim();
    const cssClass = [this.props.options && this.props.options.className, "Controller__controller"];
    return (
      <>
      <div className={this.state.controllerContainerClassName}>
      <div data-test-id={this.props.testId} className={cssClass.join(' ')}>

        <div className={this.class(Types.Wrapper) + ' ' + "Controller__important"}>
          {this.getPlayBtn()}
          {this.getVideoRange()}
          <div
            className={this.class(Types.Text) + ' ' + "Controller__extra font-regular"}
            style={{ minWidth: (Timecode.secondsToTimecodeMaxWidth(this.props.data.totalTime).length + 'ch') }}
          >
            {timeLeftStr}
          </div>
        </div>
        <div className={this.class(Types.Box)}>
          <VolumeController
            data={{ mute: this.props.data.mute, volume: this.props.data.volume || 75 }}
            options={{
              buttonClassName: this.class(Types.Button),
              volumnRangeClassName: this.class(Types.Slider) + ' ' + "Controller__volumeMaxMinWidth",
              modal: this.props.options?.modal
            }}
            events={{
              onClick: this.handleMuteUnmute,
              onVolumeChange: this.handleMuteUnmute,
            }}
          />
        </div>
        {this.getBox()}
      </div>
      </div>
      {/*
              // @ts-ignore */}
              <style jsx global>{`
              .Controller__controller {
                flex: 0 0 auto;
                -ms-flex: 0 0 auto;
                display: flex;
                align-items: center;
                min-height: 40px;
                clear: both;
                position: relative;
                width: 100%;
                flex-shrink: 0;
                flex-wrap: wrap;
                justify-content: space-between;
                /*padding 1 fixes weird sub-pixel aliasing*/
                padding: 1px;
                border-radius: 0 0 7px 7px;
              }
              
              .Controller__container {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0px 10px;
              }
              .Controller__container.Controller__large {
                margin: 10px;
              }
              .Controller__container:first-child {
                margin-left: 0;
              }
              .Controller__container:nth-last-child(2) {
                margin-right: 0;
              }

              .Controller__button.Controller__down svg{
                color: #009fdb;
              }

              .Controller__button svg:hover {
                color: #009fdb;
              }
              
              .Controller__button {
                flex: 1 1 auto;
                padding: 0 3px;
                order: 1;
                margin: 0 3px;
                height: 35px;
                max-height: 35px;
                order: 1;
                color: #fff;
                font-size: 1em;
                fill: #999999;
                border-radius: 3px;
                border: 0;
                font-size: 35px;
                cursor: pointer;
                background-color: transparent;
                color: #dcdfe3;
                width: 45px;
                max-width: 45px;
              }
              .Controller__button.Controller__large {
                height: 35px;
                max-height: 45px;
              }
              .Controller__button:first-child {
                margin-left: 0;
              }
              .Controller__button.Controller__down::before {
                color: #009fdb;
              }
              .Controller__button svg:hover {
                color: #009fdb;
              }
              
              .Controller__range {
                flex: 1 1 auto;
                padding: 0 3px;
                order: 1;
                margin: 0 3px;
                height: 35px;
                max-height: 35px;
                order: 1;
                color: #fff;
                font-size: 1em;
                margin: 0;
              }
              .Controller__range.Controller__large {
                height: 35px;
                max-height: 45px;
              }
              .Controller__range:first-child {
                margin-left: 0;
              }
              .Controller__range:last-child {
                padding-left: 10px;
              }
              
              .Controller__text {
                flex: 1 1 auto;
                padding: 0 3px;
                order: 1;
                margin: 0 3px;
                height: 35px;
                max-height: 35px;
                order: 1;
                color: #fff;
                font-size: 1em;
                height: auto;
                max-height: none;
                text-align: center;
              }
              .Controller__text.Controller__large {
                height: 35px;
                max-height: 45px;
              }
              .Controller__text:first-child {
                margin-left: 0;
              }
              
              .Controller__flexible {
                flex: 1 1 auto;
              }
              
              .Controller__inflexible {
                flex: 0 0 auto;
              }
              
              .Controller__volumeMaxMinWidth {
                max-width: 60px !important;
                min-width: 60px;
              }
              @media screen and (max-width:600px) {
                .Controller__controller .Controller__extra {
                  display: none;
                }
                
                .Controller__controller .Controller__range:first-child {
                  margin-left: 0;
                }
                
                .Controller__controller .Controller__range:last-child {
                  display: none;
                }
              }
              @media screen and (max-width:400px) {
                .Controller__controller .Controller__important {
                  order: 0;
                }
              }
              @media screen and (max-width:250px) {
                .Controller__controller .Controller__item {
                  margin: 0;
                  padding: 0;
                } 
              }

              .Controller__controller__GT400__LT600 .Controller__controller .Controller__extra,
              .Controller__controller__GT250__LT400 .Controller__controller .Controller__extra,
              .Controller__controller__LT250 .Controller__controller .Controller__extra {
                display: none;
              }
              
              .Controller__controller__GT400__LT600 .Controller__controller .Controller__range:first-child,
              .Controller__controller__GT250__LT400 .Controller__controller .Controller__range:first-child,
              .Controller__controller__LT250 .Controller__controller .Controller__range:first-child {
                margin-left: 0;
              }
              
              .Controller__controller__GT400__LT600 .Controller__controller .Controller__range:last-child,
              .Controller__controller__GT250__LT400 .Controller__controller .Controller__range:last-child,
              .Controller__controller__LT250 .Controller__controller .Controller__range:last-child {
                display: none;
              }

              .Controller__controller__GT250__LT400 .Controller__controller .Controller__important,
              .Controller__controller__LT250 .Controller__controller .Controller__important {
                order: 0;
              }

              .Controller__controller__LT250 .Controller__controller .Controller__item {
                margin: 0;
                padding: 0;
              } 

      `}</style>
     </> 
    );
  }

  getBox = () => {
    if (this.props.data && this.props.data.chapteredVideoData && this.props.data.chapteredVideoData.length > 0) {
      return (
        <div className={this.class(Types.Box)}>
          {this.props.options && this.props.options.showCaption && this.getCCBtn()}
          {this.props.options && this.props.options.showFullScreen && this.getFullscreenBtn()}
          {this.props.options && this.props.options.showTranscript && this.getTranscriptBtn()}
        </div>
      );
    } else {
      return (
        <div className={this.class(Types.Box)}>
          {this.props.options && this.props.options.showCaption && this.getCCBtn()}
          {this.props.options && this.props.options.showTranscript && this.getTranscriptBtn()}
          {this.props.options && this.props.options.showFullScreen && this.getFullscreenBtn()}
        </div>
      );
    }
  }

  handleMuteUnmute(mute: boolean, volumn: number) {
    if (this.props.events && this.props.events.handleMute) {
      this.props.events.handleMute(mute, volumn);
    }
  }

  getPlayBtn(): any {
    const playing = this.state.playing;

    return (
      <button
        className={this.class(Types.Button)}
        onClick={this.handlePlayPause}
        aria-label={'Play Pause'}
        report-title={playing ? 'Pause Button' : 'Play Button'}
        title={playing ? 'Video is Playing' : 'Video is Paused'}
        aria-pressed={playing ? 'true' : 'false'}
      >
        {
          playing
            ? <IconSvg size={IconSvgSizes.MD} svgNodeStr={pauseIcon} altText={'video pause Icon Controller'} />
            : <IconSvg size={IconSvgSizes.MD} svgNodeStr={playIcon} altText={'video play Icon Controller'} />
        }
      </button>
    );
  }

  handlePlayPause() {
    this.setState({ playing: !this.state.playing });
    if (this.props.events && this.props.events.handlePlayPause) {
      this.props.events.handlePlayPause(!this.state.playing);
    }
  }

  getVideoRange(): any {
    const reflect = this.props.data.currentTime >= this.props.data.totalTime ?
      this.props.data.totalTime : this.props.data.currentTime;
    return (
      <RangeComponent
        data={{
          accessabiltyText: 'Seek Video',
          chapteredVideoData: this.props.data.chapteredVideoData,
          reportTitle: 'Seek Slider',
          valueMax: this.props.data.totalTime,
        }}
        options={{
          className: "Controller__range",
          reflect,
          tooltip: true,
          tooltipFormat: TooltipFormat.Timecode,
          modal: this.props.options?.modal 
        }}
        events={{ update: this.handleVideoRange }}
      />
    );
  }

  handleVideoRange(value: number) {
    if (this.props.events && this.props.events.handleSeekVideo) {
      this.props.events.handleSeekVideo(value);
    }
  }

  getCCBtn(): any {
    const cssClass = [this.class(Types.Button, this.state.showCaption)];
    return (
      <button
        className={cssClass.join(' ')}
        onClick={this.hanldeCaptionbuttonClick}
        aria-label={'Closed Captions'}
        report-title={'Captions Toggle'}
        title={this.state.showCaption ? 'Closed Captions On' : 'Closed Captions Off'}
        aria-pressed={this.state.showCaption ? 'true' : 'false'}
      >
        <IconSvg size={IconSvgSizes.MD} svgNodeStr={ccIcon} altText={'caption Icon Controller'}/>
      </button>
    );
  }

  hanldeCaptionbuttonClick(e: React.FormEvent<HTMLButtonElement>) {
    this.setState({ showCaption: !this.state.showCaption });
    if (this.props.events && this.props.events.captionClick) {
      this.props.events.captionClick(!this.state.showCaption);
    }
  }

  getFullscreenBtn(): any {
    const breakpoint = Utils.getBreakPoint();
    let cssClass = [];
    if (breakpoint > 767) {
      cssClass = [this.class(Types.Button, this.state.fullScreen)];

      return (
        <button
          className={cssClass.join(' ')}
          onClick={this.handleFullScreen}
          aria-label="Fullscreen Video"
          title="Fullscreen Video"
          report-title="Full screen Toggle"
          aria-pressed={this.state.fullScreen ? 'true' : 'false'}
        >
          {this.state.fullScreen
            ? <IconSvg size={IconSvgSizes.MD} svgNodeStr={fullScreenExitIcon} altText={'full screen Exit Icon'} />
            : <IconSvg size={IconSvgSizes.MD} svgNodeStr={fullScreenIcon} altText={'full screen View Icon'} />
          }
        </button>
      );
    }
  }

  handleFullScreen(e: React.FormEvent<HTMLButtonElement>) {
    this.setState({ fullScreen: !this.state.fullScreen });
    if (this.props.events && this.props.events.fullScreenClick) {
      this.props.events.fullScreenClick(!this.state.fullScreen);
    }
  }

  getTranscriptBtn(): any {
    let cssClass;
    let title;
    let transcriptIcon = '';

    // if (this.minimal) return;
    if (this.props.data.chapteredVideoData.length > 0) {
      title = !this.state.showTranscript ? 'Playlist Open' : 'Playlist Closed';
      transcriptIcon = !this.state.showTranscript ? transcriptCollapse : transcriptOpen;
      cssClass = [this.class(Types.Button, !this.state.showTranscript)];
    } else {
      transcriptIcon = this.state.showTranscript ? transcriptCollapse : transcriptOpen;
      cssClass = [this.class(Types.Button, this.state.showTranscript)];
      title = this.state.showTranscript ? 'Transcript Open' : 'Transcript Closed';
    }
    return (
      <button
        className={cssClass.join(' ')}
        onClick={this.handleTranscriptClick}
        aria-label="Video Transcript"
        report-title="Transcript Toggle"
        aria-expanded={this.state.showTranscript ? 'true' : 'false'}
        aria-controls="gvpTranscriptPanel"
        title={title}
      >
        <IconSvg size={IconSvgSizes.MD} svgNodeStr={transcriptIcon} altText={'transcript Icon Controller'}/>
      </button>
    );
  }

  handleTranscriptClick(e: React.FormEvent<HTMLButtonElement>) {
    this.setState({ showTranscript: !this.state.showTranscript });
    if (this.props.events && this.props.events.transcriptClick) {
      this.props.events.transcriptClick(!this.state.showTranscript);
    }
  }

  private class(type: Types, option?: any): string {
    const enlarge = this.props.options && this.props.options.enlarge;
    switch (type) {
      case Types.Box:
        return "Controller__container" + ' ' + "Controller__inflexible" + (enlarge ? ' ' + "Controller__large" : '');
      case Types.Wrapper:
        return "Controller__container" + ' ' + "Controller__flexible" + (enlarge ? ' ' + "Controller__large" : '');
      case Types.Button:
        return "Controller__button" + ' ' + (enlarge ? ' ' + "Controller__large" : '') + (option ? ' ' + "Controller__down" : '');
      case Types.Slider:
        return "Controller__range" + (enlarge ? ' ' + "Controller__large" : '');
      case Types.Text:
        return "Controller__text" + ' ' + "Controller__inflexible";
    }
  }
}

export default Controller;